export default "__VITE_ASSET__241ba851__"